export default "__VITE_ASSET__CRSyvS_O__"